module.exports = __webpack_public_path__ + "static/tmp-blog-ads-2-fdf3e164efc8b4e3d98b07a4bbd359ab.png";